import { fetchAPI } from '@utils/http/apiRequest'

const path = '/restapi/v1/get/customer/is-login'
export const getCustomerIsLogin = async (cookieHeader?: string) => {
	return fetchAPI({ path, cookieHeader })
}
